const isCar = valor => {
    if (!valor) {
        return false;
    }

    let valorSemFormatacao = valor.replace(/[^a-zA-Z0-9]/g, '').trim();

    if (valorSemFormatacao.length !== 41) {
        return false;
    }

    return /^[A-Z]{2}\d{7}[A-Za-z0-9]{32}$/.test(valorSemFormatacao);
};

const addMascaraCar = valor => {
    if (!valor) {
        return '';
    }

    let valorSemFormatacao = valor.replace(/[^a-zA-Z0-9]/g, '').trim();

    return valorSemFormatacao.replace(/(.{2})(.{7})(.*)/, '$1-$2-$3');
};

export default {
    isCar,
    addMascaraCar
};
